import { LOCAL_ENVIRONMENT } from "../environment";

export const FRONTEND_ROUTES = {
    SOCIAL_INSTA : 'https://www.instagram.com/medcleir/',
    SOCIAL_TWITTER : 'https://x.com/MedCleir',
    SOCIAL_TIKTOK : 'https://www.tiktok.com/@medcleir',
    SOCIAL_FACEBOOK : 'https://www.facebook.com/medcleir',
    SOCIAL_YOUTUBE : 'https://www.youtube.com/@MedCleir',
    SOCIAL_PINTEREST : 'https://pinterest.com/MedCleir/',
    SOCIAL_REDDIT : 'https://www.reddit.com/user/MedCleir/',
    SOCIAL_GITHUB : 'https://github.com/MedCleir',
    SOCIAL_LINKEDIN : 'https://www.linkedin.com/company/medcleir/',
    SOCIAL_TELEGRAM : 'https://t.me/MedCleir',

    // Toggles between http://localhost:3000 and the production URL
    SERVER: LOCAL_ENVIRONMENT 
        ? 'http://localhost:3000' 
        : (process.env.REACT_APP_URL || 'https://medcleir.com'),
    test: '/test',
    login: '/login',
    profile: '/profile',
    dashboard: '/dashboard',
    register: '/register',
    profile_onboarding: '/profile_onboarding',
    patient_to_pro: '/patient_to_pro',
    pro_onboarding: '/pro_onboarding',
    pro_to_patient: '/pro_to_patient',
    pro_verification_pending: '/pro_verification_pending',
    onboarding_success: '/onboarding_success',

    register_professional: '/register_professional',
    verify: '/verify',
    landing: '/landing',
    socials: '/socials',
    auth: '/auth',
    whitelist: '/whitelist',
    confirm_email: '/confirm',
    home: '/home/*',
    home_search: '/home/search',
    home_profile: '/home/profile',
    home_emergency_contacts: '/home/emergency_contacts',
    home_privacy: '/home/privacy',
    home_billing: '/home/billing',
    home_settings: '/home/settings',

    /*    START General Settings    */

      // settings groups
  // General Settings
  settings_x1: "/settings/x1",
  settings_x2: "/settings/x2",
  settings_x3: "/settings/x3",
  settings_x4: "/settings/x4",

    /*    END General Settings    */



    request_access_static: '/request_access',
    request_access_dynamic: '/request_access/:username',

    invited_static: 'invited/',
    invited_dynamic: '/invited/:username',


    static_search: '/search',
    relative_search: '/search/:query?',
    
    static_about: '/about',
    relative_about: '/about/:sectionId?',
    about_company: '/about/company',
    about_news: '/about/news',
    about_staff:'/about/staff',
    about_jobs: '/about/jobs',
    about_contact: '/about/contact',

    static_professionals: '/professionals',
    relative_professionals: '/professionals/:sectionId?',
    professionals_faq: '/professionals/faq',
    professionals_help: '/professionals/help',
    professionals_privacy: '/professionals/privacy',
    professionals_pricing: '/professionals/pricing',
    professionals_manual: '/professionals/manual',

    static_patients: '/patients',
    relative_patients: '/patients/:sectionId?',

    patients_faq: '/patients/faq',
    patients_help: '/patients/help',
    patients_privacy: '/patients/privacy',
    patients_pricing: '/patients/pricing',

  };
  
